import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

type LessonTypeProps = {
  lessonType: string;
};

function LessonType({ lessonType }: LessonTypeProps) {
  switch (lessonType.toLowerCase()) {
    case 'went well': {
      return (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          sx={(theme) => ({ color: theme.palette.custom.greenBlue })}
        >
          <Circle sx={(theme) => ({ backgroundColor: theme.palette.custom.greenBlue })} />
          {lessonType}
        </Box>
      );
    }

    case 'needs improvement': {
      return (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          sx={(theme) => ({ color: theme.palette.custom.redWine })}
        >
          <Circle sx={(theme) => ({ backgroundColor: theme.palette.custom.redWine })} />
          {lessonType}
        </Box>
      );
    }

    default: {
      return (
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          sx={(theme) => ({ color: theme.palette.custom.black })}
        >
          <Circle sx={(theme) => ({ backgroundColor: theme.palette.custom.black })} />
          {lessonType}
        </Box>
      );
    }
  }
}

const Circle = styled(Box, { label: 'Circle' })(({ theme }) => ({
  height: 10,
  width: 10,
  borderRadius: '50%',
  marginLeft: '2px',
}));

export default LessonType;
